var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer-clock"},[_c('div',{staticClass:"pie-wrapper pie-wrapper--solid",class:`progress-${_vm.getPercentageProgress}`,style:(`width:${_vm.width};height:${_vm.height};`),attrs:{"id":_vm.id}}),_c('b-tooltip',{attrs:{"target":_vm.id,"variant":"primary"}},[_vm._v(_vm._s(_vm.getPercentageNum)+"%")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }